// I1-I2 (her answers H4-1 and H4-2, 2026-10-19) — THE LIVE LANE OF HER QUEUE. A live comment the community
// gate held, a live comment a viewer reported, and a live a viewer reported. Props in and tree out, like her
// DMs lane, so a gate can CALL it. The server decides who may act and composes the sentence she is shown.
import { useState } from "react";
import { stamp } from "./ModerationRow";

export type LiveQueueComment = {
  id: string; sessionId: string; authorId: string; authorName: string; body: string; at: string;
  held: boolean; heldReason: string | null; liveTitle: string; reports: number; reportRead: string | null;
};
export type LiveQueueSession = {
  id: string; hostId: string; hostName: string; title: string; startedAt: string; ended: boolean; reports: number;
};
export type LiveDecision = { kind: "comment" | "live"; id: string; action: "show" | "remove" | "dismiss" | "end" };

export function OwnerLiveLane({ comments, sessions, onDecide, onOpenMember }: {
  comments: LiveQueueComment[]; sessions: LiveQueueSession[];
  onDecide: (d: LiveDecision) => void; onOpenMember?: (id: string) => void;
}) {
  const [ending, setEnding] = useState("");
  if (!comments.length && !sessions.length) return null;
  const name = (id: string, n: string) => (onOpenMember
    ? <button type="button" className="owner-link" onClick={() => onOpenMember(id)}>@{n}</button>
    : <strong>@{n}</strong>);
  return (
    <div className="owner-lr__live">
      <h3 className="owner-lr__logtitle">Live</h3>
      {sessions.map((s) => (
        <div key={`live-${s.id}`} className="owner-lr__liverow">
          <p className="owner-lr__livehead">
            {name(s.hostId, s.hostName)}'s live{s.title ? `: ${s.title}` : ""} <span>{stamp(s.startedAt)}</span>
          </p>
          <p className="owner-page__note">Reported by {s.reports} {s.reports === 1 ? "viewer" : "viewers"}.{s.ended ? " It has ended." : " It is still on."}</p>
          <div className="owner-lr__liveacts">
            <button type="button" className="button button--ghost" onClick={() => onDecide({ kind: "live", id: s.id, action: "dismiss" })}>Dismiss</button>
            {!s.ended ? (
              ending === s.id
                ? <button type="button" className="button" onClick={() => { setEnding(""); onDecide({ kind: "live", id: s.id, action: "end" }); }}>Tap again to end it</button>
                : <button type="button" className="button" onClick={() => setEnding(s.id)}>End the live</button>
            ) : null}
          </div>
        </div>
      ))}
      {comments.map((c) => (
        <div key={`livec-${c.id}`} className="owner-lr__liverow">
          <p className="owner-lr__livehead">
            {name(c.authorId, c.authorName)} in a live{c.liveTitle ? ` (${c.liveTitle})` : ""} <span>{stamp(c.at)}</span>
          </p>
          <p className="owner-lr__livebody">{c.body}</p>
          <p className="owner-page__note">
            {c.held ? "Held by the filter. The author sees it; nobody else does." : ""}
            {c.held && c.reports ? " " : ""}
            {c.reports ? `Reported by ${c.reports} ${c.reports === 1 ? "viewer" : "viewers"}.` : ""}
            {c.reportRead ? ` ${c.reportRead}` : ""}
          </p>
          <div className="owner-lr__liveacts">
            <button type="button" className="button button--ghost" onClick={() => onDecide({ kind: "comment", id: c.id, action: "show" })}>{c.held ? "Show it" : "Keep it"}</button>
            <button type="button" className="button" onClick={() => onDecide({ kind: "comment", id: c.id, action: "remove" })}>Take it down</button>
          </div>
        </div>
      ))}
    </div>
  );
}
